<template>
  <svg
    width="22px"
    height="22px"
    viewBox="0 0 22 22"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
  >
    <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
      <g transform="translate(-1.000000, -1.000000)" fill="#817A81">
        <path
          d="M12.75,16.5 L12.75,9.75 L9.75,9.75 L9.75,11.25 L11.25,11.25 L11.25,16.5 L9,16.5 L9,18 L15,18 L15,16.5 L12.75,16.5 Z M12,5.25 C11.3786797,5.25 10.875,5.75367966 10.875,6.375 C10.875,6.99632034 11.3786797,7.5 12,7.5 C12.6213203,7.5 13.125,6.99632034 13.125,6.375 C13.125,5.75367966 12.6213203,5.25 12,5.25 L12,5.25 Z M12,22.5 C6.20101013,22.5 1.5,17.7989899 1.5,12 C1.5,6.20101013 6.20101013,1.5 12,1.5 C17.7989899,1.5 22.5,6.20101013 22.5,12 C22.5,17.7989899 17.7989899,22.5 12,22.5 L12,22.5 Z M12,3 C7.02943725,3 3,7.02943725 3,12 C3,16.9705627 7.02943725,21 12,21 C16.9705627,21 21,16.9705627 21,12 C21,7.02943725 16.9705627,3 12,3 Z"
          id="Fill"
        ></path>
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  name: 'Info'
};
</script>
